import { createContext, useContext, useEffect, useState, useCallback } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EventsModuleContext = createContext({
  eventsEnabled: true,
  loading: true,
  refresh: () => Promise.resolve(),
});

export const EventsModuleProvider = ({ children }) => {
  const [eventsEnabled, setEventsEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/modules/events`);
      if (res.ok) {
        const data = await res.json();
        setEventsEnabled(data.enabled !== false);
      }
    } catch {
      // Fail-open for the public site: if the module flag can't be fetched,
      // assume enabled so the site renders normally.
      setEventsEnabled(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <EventsModuleContext.Provider value={{ eventsEnabled, loading, refresh }}>
      {children}
    </EventsModuleContext.Provider>
  );
};

export const useEventsModule = () => useContext(EventsModuleContext);
